import * as React from 'react'
import { FunctionComponent, useCallback, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useThunkDispatch from '../common/useThunkDispatch'
import AuthLayout from './AuthLayout'
import Alert from '../components/Alert'
import Input from '../components/Input'
import Button from '../components/Button'
import { requestLogin } from './authActions'

const Login: FunctionComponent = () => {
  const dispatch = useThunkDispatch()
  const navigate = useNavigate()

  const resetPasswordUrl = '/password/forgot'

  const [error, setError] = useState<string | null>(null)
  const [fetching, setFetching] = useState(false)

  const emailRef = useRef<HTMLInputElement>(null)
  const passwordRef = useRef<HTMLInputElement>(null)

  const onSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      setFetching(true)
      const error = (await dispatch(
        requestLogin(emailRef.current!.value, passwordRef.current!.value),
      )) as any
      setFetching(false)
      if (error) {
        setError(error)
      } else {
        navigate('/')
      }
    },
    [navigate],
  )

  return (
    <AuthLayout>
      <form onSubmit={onSubmit}>
        {error && <Alert>{error}</Alert>}

        <div className="form_group">
          <Input id="login-email" label="email" ref={emailRef} />
        </div>
        <div className="form_group">
          <Input
            id="login-password"
            label="password"
            type="password"
            autoComplete="current-password"
            ref={passwordRef}
          />
        </div>

        <div className="form_buttons">
          <Button
            type="submit"
            disabled={fetching}
            loading={fetching}
            className="form_control -size"
            caliber="sm"
            data-testid="login-submit"
          >
            Sign in
          </Button>
          {resetPasswordUrl && (
            <a
              className="button -sm primary-link"
              href="#"
              onClick={(e) => {
                e.preventDefault()
                const email = emailRef.current?.value
                const forgotPasswordUrl = `${resetPasswordUrl}?email=${encodeURIComponent(email as string)}`
                window.location.href = forgotPasswordUrl as string
              }}
            >
              Forgot password
            </a>
          )}
        </div>
      </form>
    </AuthLayout>
  )
}

export default Login
